import React from "react";
import {Link} from 'react-router-dom';
import {matchPath} from "react-router";
import AppRouteInfo from "../../routers/AppRouter/info";
import {PermissionSubscriptionCheck} from "./helper/PermissionSubscriptionCheck";

// Only appRoutes is checked since only appRoutes have permission (not storeRoutes & publicRoutes)
export function getMatch(to) {
    for (const route of AppRouteInfo) {
        const match = matchPath(to, {...route, exact: true});
        if (match)
            return match;
    }
    return null;
}

// React Component
function LinkAccess(props) {
    const { to, newWindow, children } = props;

    // Find match
    const match = getMatch(to);

    // If not matched
    if (!match) {
        return (
            <Link to={to}>
                { children || null}
            </Link>
        );
    }

    // Check permission if matched
    const { allowed } = PermissionSubscriptionCheck.withUrl(match.path).hasPermissionTo();

    if (allowed) {
        // sales/purchases payment/refund invoices will open in new window
        return (
            <Link to={to} target={newWindow ? "_blank" : null}>
                {children || null}
            </Link>
        );
    }

    return children || null;
}

export default LinkAccess;
